// extracted by mini-css-extract-plugin
module.exports = {"wbh_payload_body_form_data_textarea":"Styles_wbh_payload_body_form_data_textarea__3OuJF","wbh_raw_body_ps":"Styles_wbh_raw_body_ps__2UIhm"};